import React from 'react';
import Moment from 'moment';

export default function AttachedAppointments({appointments, order}) {
  console.log('appointments', appointments);
  return (
    <div className="col-md-4 client-details">
      <div className="client-info">
        <div className="card shadow-sm">
          <div className="card-header" style={{backgroundColor: '#404040', color: 'white'}}>
            Attached appointments ({appointments.length})
          </div>
          <div className="card-body">
            <div id="" className="mb-3 all_attached_appointmnets">
              <div className="table-responsive">
                {appointments.length > 0 ? (
                  <table className="table _tableCommon">
                    <tbody>
                      {appointments.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <span className="_finalDate">
                                <span
                                  className="_icon"
                                  style={{display: 'flex', alignItems: 'center', gap: '5px'}}
                                >
                                  {index + 1}
                                  {')'}
                                  <img
                                    className="confirmBookIcon"
                                    src="https://circadnwebsite.s3.amazonaws.com/images/calendar_event.png"
                                    alt=""
                                    style={{height: '20px', width: '20px'}} // Adjust size as needed
                                  />
                                </span>
                                <p>{Moment(item.start_branch_time).format('MM-DD-YYYY')}</p>
                              </span>
                              <div
                                style={{
                                  color: '#807e7e',
                                  fontSize: '15px',
                                  fontWeight: 'bold',
                                }}
                              >
                                {Moment(item.start_branch_time).format('hh:mm A')} -{' '}
                                {Moment(item.end_branch_time).format('hh:mm A')}
                              </div>
                              {item.typename === 'appointment' && (
                                <div>
                                  {' '}
                                  <b>Member: </b>
                                  {item?.memberFirstName + ' ' + item?.memberLastName}
                                </div>
                              )}
                              {item.trainerName !== undefined && (
                                <div>
                                  <b>Coach: </b>
                                  {item.trainerName ?? ''}
                                </div>
                              )}
                              {item.serviceName !== undefined && (
                                <div>
                                  <b>Service: </b>
                                  {item.serviceName ?? ''}
                                </div>
                              )}
                              {item.packageLabel !== undefined && (
                                <div>
                                  <b>Package: </b>
                                  {order.packageLabel ?? ''}
                                </div>
                              )}
                              {item.status === 'cancelled' && item.typename === 'appointment' && (
                                <div className="row">
                                  <div className="col-md-9">
                                    <b>Cancelled By: </b>
                                    {item.canByN ?? ''}
                                    <br />
                                    <b>Cancellation Type: </b>
                                    {item?.cancelType === 'refund'
                                      ? item?.refundType === 'partial'
                                        ? 'Cancel and Partial Refund'
                                        : 'Cancel and Full Refund'
                                      : item?.cancelType === 'session_credit'
                                      ? 'Cancel and Credit'
                                      : 'Cancel with no Credit'}
                                    <br />
                                    {(item.cancelType === 'session_credit' ||
                                      item.cancelType === 'individual') && (
                                      <>
                                        <b>Credit given: </b> Yes
                                      </>
                                    )}
                                  </div>
                                  <div className="col-md-3">
                                    <span className="badge badge-danger mr-2">Cancelled</span>
                                    <br />
                                    {item.cancelType === 'refund' && (
                                      <span className="badge badge-success mr-2">REFUNDED</span>
                                    )}
                                  </div>
                                </div>
                              )}

                              {item.typename === 'group_class_members' && (
                                <>
                                  {/* {!(item.status && item.status === 'cancelled') && (
                                                                    <div>
                                                                        <b>Family Members11 :</b>{' '}
                                                                        {item.familyMembers.map((fm, i) => (
                                                                            <span key={'fm' + i}>
                                                                                    {fm.isParent && (
                                                                                        `${item.memberFirstName || ''} ${item.memberLastName || ''}`
                                                                                    )}
                                                                                {fm.firstName && (
                                                                                    ` ${fm.firstName} ${fm.lastName || ''}${i !== item.familyMembers.length - 1 ? ', ' : ''}`
                                                                                )}
                                                                                </span>
                                                                        ))}
                                                                    </div>
                                                                )} */}
                                  <div>
                                    <b>Active Family Members booked in this order:</b>{' '}
                                    {item.FM_OrderData?.filter(fm => fm?.status !== 'cancelled' || item?.status !== 'cancelled')
                                      .sort((a, b) => {
                                        const nameA = `${a.firstName || ''} ${
                                          a.lastName || ''
                                        }`.toLowerCase();
                                        const nameB = `${b.firstName || ''} ${
                                          b.lastName || ''
                                        }`.toLowerCase();
                                        if (nameA < nameB) return -1;
                                        if (nameA > nameB) return 1;
                                        return 0;
                                      })
                                      .map((fm, i, arr) => (
                                        <span key={'fmActive' + i}>
                                          {fm?.firstName} {fm?.lastName || ''}
                                          {i < arr.length - 1 ? ',' : ''}
                                        </span>
                                      ))}
                                  </div>
                                  {item.FM_OrderData?.filter(fm => fm?.status === 'cancelled' || item?.status === 'cancelled')
                                    .length > 0 && (
                                    <div>
                                      <b>Family Members cancelled from this order:</b>{' '}
                                      <table
                                        style={{color: '#171717', backgroundColor: '#c4c6c83b'}}
                                      >
                                        <tbody>
                                          {item.FM_OrderData?.filter(
                                            fm => fm?.status === 'cancelled' || item?.status === 'cancelled'
                                          )
                                            .sort((a, b) => {
                                              const nameA = `${a.firstName || ''} ${
                                                a.lastName || ''
                                              }`.toLowerCase();
                                              const nameB = `${b.firstName || ''} ${
                                                b.lastName || ''
                                              }`.toLowerCase();
                                              if (nameA < nameB) return -1;
                                              if (nameA > nameB) return 1;
                                              return 0;
                                            })
                                            .map((fm, i) => {
                                              return (
                                                <tr key={'fmCancel' + i}>
                                                  <td>
                                                    <b>
                                                      {i + 1}
                                                      {'.'}
                                                    </b>{' '}
                                                    <strong>
                                                      {fm?.firstName} {fm?.lastName || ''}
                                                    </strong>
                                                    <br />
                                                    Cancellation Type:{' '}
                                                    <span style={{fontSize: '12px'}}>
                                                      {fm?.cancelType === 'refund'
                                                        ? fm?.refundType === 'partial'
                                                          ? 'Cancel and Partial Refund'
                                                          : 'Cancel and Full Refund'
                                                        : fm?.cancelType === 'session_credit'
                                                        ? 'Cancel and Credit'
                                                        : 'Cancel with no Credit'}
                                                    </span>
                                                    <br />
                                                    {(fm.cancelType === 'session_credit' ||
                                                      fm.cancelType === 'individual') && (
                                                      <>
                                                        <b>Credit given : </b> Yes
                                                        <br />
                                                      </>
                                                    )}
                                                    {fm.cancelType === 'refund' &&
                                                      `Refund : ${fm.refundType}`}
                                                    <br />
                                                  </td>
                                                  <td>
                                                    <span className="badge badge-danger mr-2">
                                                      Cancelled
                                                    </span>
                                                    <br />
                                                    {fm.cancelType === 'refund' && (
                                                      <span className="badge badge-success mr-2">
                                                        REFUNDED
                                                      </span>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div className="alert alert-warning" role="alert">
                    No appointments are attached to this order.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
